import { connect, MapStateToProps } from 'react-redux';
import { Props } from './BillingCyclePopup';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  getGiftUser,
  getSale,
  getPackageProducts,
} from '../../../../redux/packagePicker/selectors';

export type StateProps = Pick<
  Props,
  | 'filteredPackageProducts'
  | 'sale'
  | 'alreadyHasSubscription'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (
  state,
  ownProps
) => {
  return {
    filteredPackageProducts: getPackageProducts(state).filter(p =>
      ownProps.selectedPackage?.includes(p.subproductId)
    ),
    giftUser: getGiftUser(state),
    sale: getSale(state),
    alreadyHasSubscription: ownProps.giftUser
      ? false
      : getCurrentUserHasCore(state),
  };
};

export default connect(mapStateToProps);
